export const servicesData = [
  {
    id: 1,
    slug: 'web-development',
    title: 'Web Development',
    icon: 'fa-solid fa-globe',
    color: '#0d6efd',
    shortDesc: 'High-performance websites and web apps built with cutting-edge technologies tailored to your business needs.',
    heroImage: 'https://images.unsplash.com/photo-1547658719-da2b51169166?w=900&q=80',
    fullDesc: `We craft powerful, scalable web solutions that drive real business results. From sleek marketing websites to complex web applications, our team delivers excellence at every layer of the stack.`,
    features: [
      'Custom responsive website design',
      'React, Next.js, Vue.js development',
      'E-commerce platforms (Shopify, WooCommerce)',
      'Progressive Web Apps (PWA)',
      'CMS integration (WordPress, Strapi)',
      'API development & integration',
      'Performance optimization & SEO',
      'Ongoing maintenance & support',
    ],
    process: [
      { step: '01', title: 'Discovery', desc: 'Understanding your goals, audience, and technical requirements.' },
      { step: '02', title: 'Design', desc: 'Wireframes and high-fidelity mockups aligned with your brand.' },
      { step: '03', title: 'Development', desc: 'Clean, scalable code with rigorous quality standards.' },
      { step: '04', title: 'Launch', desc: 'Deployment, testing, and seamless go-live support.' },
    ],
    techStack: ['React', 'Next.js', 'Node.js', 'MongoDB', 'PostgreSQL', 'AWS'],
  },
  {
    id: 2,
    slug: 'app-development',
    title: 'App Development',
    icon: 'fa-solid fa-mobile-screen-button',
    color: '#7c3aed',
    shortDesc: 'Native and cross-platform mobile apps that deliver seamless experiences on iOS and Android.',
    heroImage: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=900&q=80',
    fullDesc: `We build mobile applications that users love. Our apps combine stunning UI with rock-solid performance, whether you need iOS, Android, or cross-platform solutions.`,
    features: [
      'iOS & Android native apps',
      'React Native cross-platform development',
      'Flutter development',
      'UI/UX design for mobile',
      'App Store & Play Store deployment',
      'Push notifications & real-time features',
      'Offline functionality',
      'App maintenance & updates',
    ],
    process: [
      { step: '01', title: 'Strategy', desc: 'Define platform, audience, and core functionality.' },
      { step: '02', title: 'Prototype', desc: 'Interactive prototypes for user testing and validation.' },
      { step: '03', title: 'Build', desc: 'Agile development with bi-weekly sprint reviews.' },
      { step: '04', title: 'Deploy', desc: 'Store submission, QA testing, and launch support.' },
    ],
    techStack: ['React Native', 'Flutter', 'Swift', 'Kotlin', 'Firebase', 'GraphQL'],
  },
  {
    id: 3,
    slug: 'consultancy',
    title: 'IT Consultancy',
    icon: 'fa-solid fa-lightbulb',
    color: '#059669',
    shortDesc: 'Strategic technology guidance that aligns your IT infrastructure with your long-term business vision.',
    heroImage: 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=900&q=80',
    fullDesc: `Our expert consultants help you navigate the complex technology landscape, make informed decisions, and build a robust digital strategy that scales with your business.`,
    features: [
      'Digital transformation strategy',
      'Technology stack audit & recommendations',
      'Cloud migration planning (AWS, Azure, GCP)',
      'Software architecture design',
      'Cybersecurity assessment',
      'Team augmentation & training',
      'Vendor evaluation & selection',
      'Cost optimization strategies',
    ],
    process: [
      { step: '01', title: 'Audit', desc: 'Comprehensive review of your current technology landscape.' },
      { step: '02', title: 'Analyze', desc: 'Identify gaps, risks, and opportunities for improvement.' },
      { step: '03', title: 'Strategize', desc: 'Create a tailored roadmap aligned with your goals.' },
      { step: '04', title: 'Execute', desc: 'Hands-on support for implementation and change management.' },
    ],
    techStack: ['AWS', 'Azure', 'GCP', 'Docker', 'Kubernetes', 'Terraform'],
  },
  {
    id: 4,
    slug: 'erp-development',
    title: 'ERP Development',
    icon: 'fa-solid fa-chart-network',
    color: '#d97706',
    shortDesc: 'Custom ERP solutions that streamline your operations, boost efficiency, and give you real-time business visibility.',
    heroImage: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=900&q=80',
    fullDesc: `We develop tailored ERP systems that fit your exact business processes — not the other way around. From manufacturing to retail, our solutions unify your operations and deliver actionable insights.`,
    features: [
      'Custom ERP system design & development',
      'Inventory & supply chain management',
      'HR & payroll management modules',
      'Finance & accounting integration',
      'CRM integration',
      'Real-time reporting & dashboards',
      'Multi-location & multi-currency support',
      'Legacy system migration',
    ],
    process: [
      { step: '01', title: 'Requirements', desc: 'Deep-dive into your business processes and workflows.' },
      { step: '02', title: 'Blueprint', desc: 'Design system architecture and module mapping.' },
      { step: '03', title: 'Develop', desc: 'Iterative development with continuous stakeholder feedback.' },
      { step: '04', title: 'Go Live', desc: 'Data migration, staff training, and phased rollout.' },
    ],
    techStack: ['Python', 'Django', 'React', 'PostgreSQL', 'Redis', 'Docker'],
  },
];
